var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
// - Import react components
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate } from 'react-localize-redux';
import { Map } from 'immutable';
// - Import app components
import UserBoxList from 'components/userboxlist2';
// - Import API
// - Import actions
import * as userActions from 'store/actions/userActions';
/**
 * Create component class
 */
var FindPeopleComponent = /** @class */ (function (_super) {
    __extends(FindPeopleComponent, _super);
    /**
     * Component constructor
     * @param  {object} props is an object properties of component
     */
    function FindPeopleComponent(props) {
        var _this = _super.call(this, props) || this;
        /**
         * Scroll loader
         */
        _this.scrollLoad = function (page) {
            var loadPeople = _this.props.loadPeople;
            loadPeople(page, 10);
        };
        // Defaul state
        _this.state = {};
        return _this;
    }
    FindPeopleComponent.prototype.componentDidMount = function () {
        this.scrollLoad(0);
    };
    /**
     * Reneder component DOM
     * @return {react element} return the DOM which rendered by component
     */
    FindPeopleComponent.prototype.render = function () {
        var _a = this.props, hasMorePeople = _a.hasMorePeople, translate = _a.translate;
        var peopleInfo = Map(this.props.peopleInfo);
        return (React.createElement("div", { style: { backgroundColor: 'white', overflowY: 'hidden' } },
            React.createElement("div", { style: { width: '100%', textAlign: 'center' } }),
            React.createElement("div", { className: 'tracks' }, peopleInfo && peopleInfo.count() > 0 ? (React.createElement("div", null,
                React.createElement("div", { style: { color: '#696969', fontSize: '24px' }, className: 'profile__title' }, "Featured Designers"),
                React.createElement(UserBoxList, { users: peopleInfo }),
                React.createElement("div", { style: { height: '24px' } }))) : (React.createElement("div", { className: 'g__title-center' }, translate('people.nothingToShowLabel'))))));
    };
    return FindPeopleComponent;
}(Component));
export { FindPeopleComponent };
/**
 * Map dispatch to props
 * @param  {func} dispatch is the function to dispatch action to reducers
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapDispatchToProps = function (dispatch, ownProps) {
    return {
        loadPeople: function (page, limit) { return dispatch(userActions.dbGetPeopleInfo(page, limit)); }
    };
};
/**
 * Map state to props
 * @param  {object} state is the obeject from redux store
 * @param  {object} ownProps is the props belong to component
 * @return {object}          props of component
 */
var mapStateToProps = function (state, ownProps) {
    var people = state.getIn(['user', 'people']);
    var hasMorePeople = state.getIn(['user', 'people', 'hasMoreData'], true);
    var info = state.getIn(['user', 'info']);
    return {
        translate: getTranslate(state.get('locale')),
        peopleInfo: info,
        hasMorePeople: hasMorePeople
    };
};
// - Connect component to redux store
export default connect(mapStateToProps, mapDispatchToProps)(FindPeopleComponent);



//////////////////
// WEBPACK FOOTER
// ./src/components/findpeople2/FindPeopleComponent2.tsx
// module id = 1561
// module chunks = 0 1 2 3